<template>
  <div class="auth-layout">
    <div class="auth-background"></div>
    <div class="auth-container">
      <div class="auth-card">
        <div class="auth-header">
          <div class="auth-logo">
            <div class="auth-logo__icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
              </svg>
            </div>
            <span class="auth-logo__text">Kemaris</span>
          </div>
        </div>
        <router-view></router-view>
      </div>
      <p class="auth-footer-text">
        &copy; {{ year }} Kemaris. Alle Rechte vorbehalten.
      </p>
    </div>
  </div>
</template>

<script>
/**
 * AuthLayout - Layout for authentication pages
 * @description Modern centered card layout for login/register
 */
export default {
  name: "AuthLayout",
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  mounted() {
    // Ensure theme is set for auth pages too
    this.initializeTheme();
  },
  methods: {
    /**
     * Initializes theme from localStorage or system preference
     */
    initializeTheme() {
      try {
        const saved = localStorage.getItem("kemaris-theme");
        if (saved) {
          document.documentElement.setAttribute("data-theme", saved);
        } else {
          const prefersDark = window.matchMedia(
            "(prefers-color-scheme: dark)"
          ).matches;
          document.documentElement.setAttribute(
            "data-theme",
            prefersDark ? "dark" : "light"
          );
        }
      } catch (e) {
        document.documentElement.setAttribute("data-theme", "light");
      }
    },
  },
};
</script>

<style scoped>
.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--k-bg-secondary);
  position: relative;
  overflow: hidden;
}

.auth-background {
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(circle at 20% 20%, rgba(0, 122, 255, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(52, 199, 89, 0.06) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(175, 82, 222, 0.04) 0%, transparent 50%);
  pointer-events: none;
}

.auth-container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.auth-card {
  width: 100%;
  background: var(--k-bg-glass);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid var(--k-bg-glass-border);
  border-radius: var(--k-radius-xl);
  box-shadow: var(--k-shadow-xl);
  padding: 40px;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.auth-header {
  text-align: center;
  margin-bottom: 32px;
}

.auth-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.auth-logo__icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, var(--k-accent), #5AC8FA);
  border-radius: var(--k-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.auth-logo__icon svg {
  width: 26px;
  height: 26px;
}

.auth-logo__text {
  font-size: 24px;
  font-weight: 700;
  color: var(--k-text-primary);
  letter-spacing: -0.5px;
}

.auth-footer-text {
  margin-top: 24px;
  font-size: 12px;
  color: var(--k-text-tertiary);
}

@media (max-width: 480px) {
  .auth-card {
    padding: 32px 24px;
    border-radius: var(--k-radius-lg);
  }
}
</style>
